import { ProductTuitionDaysNumber } from '../../lib/types/models/product/product-tuition-days-number'
import { ProductTuitionDaysNumberInput } from '../../lib/types/models/product/product-tuition-days-number-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createProductTuitionDaysNumber = async (
  input: ProductTuitionDaysNumberInput & { productId: number }
) => {
  const { productId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.products.createProductTuitionDaysNumber.url, { productId }))
    .post<ProductTuitionDaysNumber, ProductTuitionDaysNumberInput>(data)
}
